<div>
  <div class="account-details-wrapper">
    <div class="alert-wrapper">
      <app-alert *ngIf="alert" [message]="alert.message" [level]="alert.level" [dismissDelay]="4000">
      </app-alert>
      <app-alert *ngIf="showOriginalAccount" [level]="'error'">
         Viewing Original Account Entries - <a class="return-account-link" (click)="showOriginalAccount = false">Return to current account</a>
      </app-alert>
    </div>
    <div *ngIf="cloning; else accountDetails" class="cloning-container">
      <mat-spinner diameter="24" class="cloning-spinner"></mat-spinner>
      <div class="cloning-text">Cloning Account...</div>
    </div>
    <ng-template #accountDetails>
      <div class="layout-row align-space-between account-header">
        <!-- account number and type -->
        <div class="layout-column align-center account-details" *ngIf="!editingAccount && !showOriginalAccount">
          <div class="account-number">{{ bankAccount.accountNumber }}</div>
          <div>{{ bankAccount.accountType }}</div>
          <!-- if there is original account , then swap the bankAccount-->
        </div>
        <div class="layout-column align-center account-details" *ngIf="showOriginalAccount">
          <div class="account-number">{{ originalAccountNumber }}</div>
          <div>{{originalAccountType }}</div>
        </div>

        <!-- if we are getting the editing value true then convert this to edit mode-->
        <div [ngClass]="fill" *ngIf="editingAccount && !showOriginalAccount" style="width: 100%;">
          <form [formGroup]="form" style="display: flex;">
            <formly-form [form]="form" [fields]="fields" [model]="model" class="edit-account-form"></formly-form>
            <button *ngIf="!saving" mat-flat-button type="button" (click)="onCancel()" style="color: #02c0ee;"
              class="edit-account-cancel-button">Cancel</button>
            <button *ngIf="saving" mat-button disabled class="edit-account-cancel-button">Cancel</button>


            <button mat-flat-button type="submit" color="primary" (click)="this.save()"
              [disabled]="!form.valid || saving">
              <span *ngIf="!saving" class="progress-button-text">Save</span>
              <mat-spinner *ngIf="saving" diameter="24" style="display: inline-block; height: 24px; width: 24px"></mat-spinner>
            </button>
          </form>
        </div>

        <!-- account controls -->
        <div class="layout-row align-space-around" *ngIf="!editingAccount && !showOriginalAccount">
          <mat-spinner class="account-control-item" *ngIf="isDeletingAccount" diameter="24"
            style="display: inline-block; height: 24px; width: 24px; margin-right: 10px; align-self: center;">
          </mat-spinner>

          <button class="account-control-item" [disabled]="isDeletingAccount" mat-flat-button
            (click)="addingAccount.emit()" *ngIf="!newFdTableView">
            <span class="material-icons add-icon v-align-middle">add</span>
            <span class="v-align-middle">Add Account</span>
          </button>
          <button class="account-control-item" [disabled]="isDeletingAccount" mat-flat-button
            (click)="addingAccountModal.emit()" *ngIf="newFdTableView">
            <span class="material-icons add-icon v-align-middle" [class]="newFdTableView ? 'blue' : ''">add</span>
            <span class="v-align-middle" [class]="newFdTableView ? 'blue' : ''">Add Account</span>
          </button>

          <button class="account-control-item" [disabled]="isDeletingAccount" mat-flat-button
            *ngIf="!bankAccount.aggregatorName" (click)="removeAccount()">
            <span class="material-icons delete-icon v-align-middle">delete</span>
            <span class="v-align-middle" [class]="newFdTableView ? 'blue' : ''"> Delete</span>
          </button>
          <button class="account-control-item" [disabled]="isDeletingAccount" mat-flat-button
            (click)="startAccountEdit()">
            <span class="material-icons edit-icon v-align-middle" [class]="newFdTableView ? 'blue' : ''">edit</span>
            <span class="v-align-middle" [class]="newFdTableView ? 'blue' : ''">Edit</span>
          </button>
        </div>
      </div>

      <!-- bank account monthly totals -->
      <app-monthly-totals-account-table
        [bankAccount]="bankAccount"
        [originalAccount]="originalAccount"
        [showOriginalAccount]="showOriginalAccount"
        [editAccount]="editingAccount"
        [retreiveMonthlySummaries]="retreiveMonthlySummaries"
        [borrowerId]="borrowerId"
        [documentLinkInfo]="documentLinkInfo"
        [newFdTableView]="newFdTableView"
        [bankValues]="bankValues"
        (editAccountOrSummaries)="onEditAccountOrSummaries($event)"
        (createMonthlySummary)="onCreateMonthlySummary($event)"
        (showOtherAccount)="onShowOriginalAccount($event)"
        (documentError)="onDocumentError($event)"
        ></app-monthly-totals-account-table>
    </ng-template>
  </div>